module.exports = __webpack_public_path__ + "img/present-bird.ab17a237.png";